module.exports = __webpack_public_path__ + "static/lesson_11-fcd469a76a3c4044e8294e244860de26.png";